<template>
  <!-- 会员管理 直播管理 会议室管理 调研管理 - 审核、查看操作项 -->
  <div class="bill-check-ope">
    <span @click="click('check')" v-if="rowData['pay_status'] * 1 === 0">审核</span>
    <span @click="click('scan')" v-if="rowData['pay_status'] * 1 === 1">查看</span>
  </div>
</template>
<script>
export default {
  name: 'billCheckOpe',
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    click(type) {
      this.$emit('on-custom-comp', {
        type: type,
        rowData: this.rowData
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bill-check-ope {
  span {
    cursor: pointer;
    color: #2D8CF0;
  }
}
</style>
